import React, { useEffect, useRef, useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import Select from "react-select";
import DatePicker, { DateObject } from "react-multi-date-picker";
import TimePicker from "react-multi-date-picker/plugins/time_picker";
import axios from 'axios';
import break_box from '../../../../images/product/products.png';
import bgimage from '../../../../images/raw_material/default_rawmaterial.png';
import dayjs from 'dayjs';
import customParseFormat from "dayjs/plugin/customParseFormat";
import { toast } from 'react-toastify';
dayjs.extend(customParseFormat);
const EditProduct = ({ show, onClose, productId, productData, refresh }) => {

  const baseURL = process.env.REACT_APP_API_BASE_URL;
  const user_id = parseInt(localStorage.getItem("user_id"), 10);
  const [serviceSttm, setServiceSttm] = useState(null);
  const [serviceEdtm, setServiceEdtm] = useState(null);
  const [packingSttm, setPackingSttm] = useState(null);
  const [packingEdtm, setPackingEdtm] = useState(null);
  const [deliverySttm, setDeliverySttm] = useState(null);
  const [deliveryEdtm, setDeliveryEdtm] = useState(null);
  const [isVisible, setIsVisible] = useState({ items: false });
  const [optionsProduct, setOptionsProduct] = useState([]);
  const [selectedOption, setSelectedOption] = useState(null);
  const [optionsItemCategory, setOptionsItemCategory] = useState([]);
  const [itemCategories, setItemCategories] = useState([{ id: Date.now() }]);
  // const [file, setFile] = useState(null);
  const imageInputRef = useRef(null);
  const [description, setDescription] = useState('');
  const [productName, setProductName] = useState('');



  const parseTimeString = (timeString) => {
    if (!timeString) return null;

    const parsed = dayjs(timeString, "hh:mm A");
    if (!parsed.isValid()) return null;

    return new DateObject({
      hour: parsed.hour(),
      minute: parsed.minute(),
      second: 0,
      format: "HH:mm", // ensures 24-hour format
      calendar: "gregorian",
      locale: "en"
    });
  };




  useEffect(() => {
    const fetchProductCategories = async () => {
      try {
        const response = await axios.get(`${baseURL}/product-categories/products/active`);
        const categories = response.data.data;

        const formattedOptions = categories.map((category) => ({
          value: category.sno,
          label: category.productcategory_name,
          schedule_start_time: category.schedule_start_time,
          schedule_end_time: category.schedule_end_time,
        }));

        setOptionsProduct(formattedOptions);
      } catch (error) {
        console.error('❌ Error fetching product categories:', error);
      }
    };

    fetchProductCategories();
  }, []);

  const formatToDateObject = (timeStr) => {
    const trimmed = timeStr.slice(0, 5); // e.g., "18:00:00" -> "18:00"
    return new DateObject({ format: "HH:mm", date: trimmed });
  };



  const [itemCount, setItemCount] = useState('');
  const [itemCategory, setItemCategory] = useState([]);
  const [groupedSubCategories, setGroupedSubCategories] = useState({});

  useEffect(() => {
    const fetchGroupedCategories = async () => {
      try {
        const response = await axios.get(`${baseURL}/grouped-item-categories`);
        const data = response.data.data;

        const categoryOptions = data.map((cat) => ({
          value: cat.itemcategory_id,
          label: cat.itemcategory_name,
        }));
        setOptionsItemCategory(categoryOptions);

        const subcategoryMap = {};
        data.forEach((cat) => {
          subcategoryMap[cat.itemcategory_id] = cat.subcategories.map((sub) => ({
            value: sub.itemsubcategory_id,
            label: sub.itemsubcategory_name,
          }));
        });
        setGroupedSubCategories(subcategoryMap);
      } catch (error) {
        console.error('Error fetching categories with subcategories:', error);
      }
    };

    fetchGroupedCategories();
  }, []);


  useEffect(() => {
    // If productData is passed from the parent, use it directly
    if (productData) {
      setProductName(productData.product_name || '');
      setDescription(productData.description || '');
      setServiceSttm(parseTimeString(productData.production_start_time));
      setServiceEdtm(parseTimeString(productData.production_end_time));
      setPackingSttm(parseTimeString(productData.packing_start_time));
      setPackingEdtm(parseTimeString(productData.packing_end_time));
      setDeliverySttm(parseTimeString(productData.delivery_start_time));
      setDeliveryEdtm(parseTimeString(productData.delivery_end_time));
      setProductColor(productData.product_color || '#000000');
      setBrandImageFile(productData.brand_image || null);
      setFile(productData.product_image || null);

      setSelectedOption(
        optionsProduct.find(opt => opt.value === productData.product_category_id) || null
      );

      // ✅ Use improved mapping logic
      const rebuiltItemCategories = (productData.item_category_list || []).map((cat, index) => ({
        id: `item_${cat.item_category_id || index}_${Date.now()}`,
        category: cat.category
          ? cat.category // Already { value, label } if passed from parent
          : {
            value: cat.item_category_id,
            label: cat.item_category_name
          },
        count: cat.count || '1',
        subcategories: (cat.subcategories || []).map(sub => ({
          value: sub.value || sub.itemsubcategory_id,
          label: sub.label || sub.itemsubcategory_name
        }))
      }));

      setItemCategory(rebuiltItemCategories.length ? rebuiltItemCategories : [{
        id: `item_0_${Date.now()}`,
        category: null,
        count: '1',
        subcategories: []
      }]);

      setItemCount(rebuiltItemCategories.length || 1);
      return; // Skip API fetch
    }

    // Otherwise, fetch from the API using productId
    const fetchProductDetails = async () => {
      try {
        const response = await axios.get(`${baseURL}/manages-products/${productId}`);
        const data = response.data.data;

        setProductName(data.product_name || '');
        setDescription(data.description || '');
        setServiceSttm(parseTimeString(data.production_start_time));
        setServiceEdtm(parseTimeString(data.production_end_time));
        setPackingSttm(parseTimeString(data.packing_start_time));
        setPackingEdtm(parseTimeString(data.packing_end_time));
        setDeliverySttm(parseTimeString(data.delivery_start_time));
        setDeliveryEdtm(parseTimeString(data.delivery_end_time));
        setProductColor(data.product_color || '#000000');
        setBrandImageFile(data.brand_image || null);
        setFile(data.product_image || null);

        setSelectedOption(
          optionsProduct.find(opt => opt.value === data.product_category_id) || null
        );

        // ✅ Use improved mapping logic for API data
        const rebuiltItemCategories = (data.item_category_list || []).map((cat, index) => ({
          id: `item_${cat.item_category_id || index}_${Date.now()}`,
          category: {
            value: cat.item_category_id,
            label: cat.item_category_name
          },
          count: cat.count || '1',
          subcategories: (cat.subcategories || []).map(sub => ({
            value: sub.itemsubcategory_id,
            label: sub.itemsubcategory_name
          }))
        }));

        setItemCategory(rebuiltItemCategories.length ? rebuiltItemCategories : [{
          id: `item_0_${Date.now()}`,
          category: null,
          count: '1',
          subcategories: []
        }]);

        setItemCount(rebuiltItemCategories.length || 1);
      } catch (error) {
        console.error('❌ Error fetching product details', error);
      }
    };

    if (productId) {
      fetchProductDetails();
    }
  }, [productId, productData, optionsProduct, baseURL]);


  const fileHandler = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      setFile(selectedFile);
    }
  };

  const removeImage = () => {
    setFile(null);
    if (imageInputRef.current) {
      imageInputRef.current.value = '';
    }
  };

  const handleAddConfig = () => {
    setItemCategories([...itemCategories, { id: Date.now() }]);
  };

  const handleDeleteConfig = (idToDelete) => {
    setItemCategories(prev => prev.filter(config => config.id !== idToDelete));
  };

  // Error states
  const [errors, setErrors] = useState({});
  const [itemcatErrors, setItemcatErrors] = useState({});

  const handleSubmit = async (e) => {
    e.preventDefault();

    const newErrors = {};
    const itemFieldErrors = {};

    // Basic field validations
    if (!productName?.trim()) newErrors.product_name = 'Product Name is required';
    if (!selectedOption) newErrors.product_category_id = 'Select Product Category';
    if (!serviceSttm) newErrors.production_start_time = 'Production Start Time is required';
    if (!serviceEdtm) newErrors.production_end_time = 'Production End Time is required';
    if (!packingSttm) newErrors.packing_start_time = 'Packing Start Time is required';
    if (!packingEdtm) newErrors.packing_end_time = 'Packing End Time is required';
    if (!deliverySttm) newErrors.delivery_start_time = 'Delivery Start Time is required';
    if (!deliveryEdtm) newErrors.delivery_end_time = 'Delivery End Time is required';

    // Force item_count to always match number of categories
    const validItemCount = itemCategory.length;
    if (validItemCount <= 0) {
      newErrors.item_count = 'At least one item category is required';
    }

    // Validate product image (only if creating or replacing)
    if (!file && !productId) {
      newErrors.product_image = 'Product image is required';
    } else if (file instanceof File && !['image/jpeg', 'image/png', 'image/webp'].includes(file.type)) {
      newErrors.product_image = 'Only JPG, PNG, or WEBP files are allowed';
    }

    // Validate brand image (only if creating or replacing)
    if (!brandImageFile && !productId) {
      newErrors.brand_image = 'Brand image is required';
    } else if (brandImageFile instanceof File && !['image/jpeg', 'image/png', 'image/webp'].includes(brandImageFile.type)) {
      newErrors.brand_image = 'Only JPG, PNG, or WEBP files are allowed';
    }

    // Validate each category and subcategory
    const cleanedItemCategory = itemCategory.map((item, index) => {
      if (!item.category) {
        itemFieldErrors[`category_${index}`] = 'Category is required';
      }
      if (!item.subcategories || item.subcategories.length === 0) {
        itemFieldErrors[`subcategory_${index}`] = 'Select at least one subcategory';
      }
      return {
        ...item,
        count: item.count && !isNaN(item.count) ? String(item.count) : "1",
      };
    });

    // Set errors
    setItemcatErrors(itemFieldErrors);
    setErrors(newErrors);

    if (Object.keys(newErrors).length > 0 || Object.keys(itemFieldErrors).length > 0) {
      return; // Stop if validation fails
    }

    // Prepare FormData
    const formData = new FormData();
    formData.append('updated_by', user_id);
    formData.append('product_name', productName);
    formData.append('product_category_id', selectedOption.value);
    formData.append('production_start_time', serviceSttm?.format?.('hh:mm A') || '');
    formData.append('production_end_time', serviceEdtm?.format?.('hh:mm A') || '');
    formData.append('packing_start_time', packingSttm?.format?.('hh:mm A') || '');
    formData.append('packing_end_time', packingEdtm?.format?.('hh:mm A') || '');
    formData.append('delivery_start_time', deliverySttm?.format?.('hh:mm A') || '');
    formData.append('delivery_end_time', deliveryEdtm?.format?.('hh:mm A') || '');
    formData.append('description', description || '');
    formData.append('product_color', productColor || '');
    formData.append('item_count', validItemCount); // Now always matches backend expectation

    if (file instanceof File) formData.append('product_image', file);
    if (brandImageFile instanceof File) formData.append('brand_image', brandImageFile);

    const item_category_list = cleanedItemCategory.map((item) => ({
      item_category_id: item.category?.value,
      count: item.count,
      subcategories: item.subcategories.map((sub) => ({
        itemsubcategory_id: sub.value,
        itemsubcategory_name: sub.label,
      })),
    }));

    formData.append('item_category_list', JSON.stringify(item_category_list));

    try {
      await axios.post(`${baseURL}/manages-products/${productId}`, formData);
      toast.success("Product updated successfully!");
      refresh();
      onClose();
    } catch (error) {
      console.error("Error updating product:", error?.response?.data || error.message);

      // Handle duplicate product error from backend (HTTP 409)
      if (error.response?.status === 409 && error.response.data?.message) {
        setErrors(prevErrors => ({
          ...prevErrors,
          product_name: error.response.data.message,  // Show inline error on product_name field
        }));
        return; // Do not show toast here
      }

      // Handle validation errors from backend (422)
      if (error.response?.status === 422 && error.response.data?.errors) {
        setErrors(error.response.data.errors);
        setItemcatErrors(error.response.data.errors); // or parse as needed
        return;
      }

      // Other errors - show toast
      toast.error(error.response?.data?.message || "Failed to update product.");
    }
  };

  const toTitleCase = (str) => {
    return str.replace(/\w\S*/g, (txt) =>
      txt.charAt(0).toUpperCase() + txt.substring(1).toLowerCase()
    );
  };

  const getImageSrc = (img) => {
    if (!img) return break_box;
    if (img instanceof File || img instanceof Blob) return URL.createObjectURL(img);
    return img;
  };

  const getTotalItemCount = () => {
    return itemCategory.reduce((acc, cur) => acc + parseInt(cur.count || 0, 10), 0);
  };

  const RemoveImage = () => {
    setFile(null);
    if (imageInputRef.current) {
      imageInputRef.current.value = '';
    }
  };

  const [productColor, setProductColor] = React.useState("#000000"); // default black or whatever

  const [file, setFile] = React.useState(null);
  const [brandImageFile, setBrandImageFile] = React.useState(null);

  const productImageInputRef = useRef(null);
  const brandImageInputRef = useRef(null);


  const removeProductImage = () => {
    setFile(null);
    if (productImageInputRef.current) {
      productImageInputRef.current.value = '';
    }
  };

  const removeBrandImage = () => {
    setBrandImageFile(null);
    if (brandImageInputRef.current) {
      brandImageInputRef.current.value = '';
    }
  };

  const [productImageError, setProductImageError] = useState('');
  const [brandImageError, setBrandImageError] = useState('');
  const handleProductImageChange = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      if (selectedFile.size > 50 * 1024) { // 50KB
        setProductImageError("Product image must be less than 50KB");
        setFile(null);
      } else {
        setFile(selectedFile);
        setProductImageError('');
      }
    }
  };

  const handleBrandImageChange = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      if (selectedFile.size > 50 * 1024) { // 50KB
        setBrandImageError("Brand image must be less than 50KB");
        setBrandImageFile(null);
      } else {
        setBrandImageFile(selectedFile);
        setBrandImageError('');
      }
    }
  };

  return (
    <Modal show={show} size="lg">
      <div className="modal-content">
        <div className="modal-header" style={{ backgroundColor: '#3ab384' }}>
          <h3 className="modal-title text-white">Edit Product</h3>
          <Button variant="" type="button" className="close px-6 py-2" onClick={onClose}>
            <span className="text-white">×</span>
          </Button>
        </div>
        <div className="modal-body">
          <form onSubmit={handleSubmit}>

            <div className="row">
              <div className='col-lg-8'>
                <div className="row">
                  <div className="col-lg-6 mb-4">
                    <label className="text-black font-w500 fs-7">
                      Product Category <span className="required">*</span>
                    </label>
                    <Select
                      placeholder="Select Product Ctgy"
                      value={selectedOption}
                      onChange={(option) => {
                        console.log("🟢 Selected Option:", option);
                        setSelectedOption(option);

                        if (option?.schedule_start_time) {
                          const startObj = formatToDateObject(option.schedule_start_time);
                          console.log("⏰ Start Time Object:", startObj.format());
                          setServiceSttm(startObj);
                        }

                        if (option?.schedule_end_time) {
                          const endObj = formatToDateObject(option.schedule_end_time);
                          console.log("⏰ End Time Object:", endObj.format());
                          setServiceEdtm(endObj);
                        }
                      }}
                      options={optionsProduct}
                    />
                    {errors.product_category_id && (
                      <div className="text-danger">{errors.product_category_id}</div>
                    )}
                  </div>
                  {/* Product Name */}
                  <div className="col-lg-6 mb-4">
                    <label className="text-black font-w500 fs-7">
                      Product Name <span className="required">*</span>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter Product Name"
                      value={productName}
                      maxLength={25}
                      onChange={(e) => {
                        const input = e.target.value;
                        const onlyLetters = input.replace(/[^a-zA-Z\s]/g, ''); // allow letters and spaces
                        setProductName(toTitleCase(onlyLetters));
                      }}
                    />
                    {errors.product_name && <div className="text-danger">{errors.product_name}</div>}
                  </div>
                  {/* Production Start Time */}
                  <div className="col-lg-6 mb-4">
                    <label className="text-black font-w500 fs-7">
                      Production Start Time <span className="required">*</span>
                    </label>
                    <div className="datepicker-wrapper d-flex border-bottom border-gray-300">
                      <div className="input-group-text bg-transparent border-0 px-0">
                        <i className="fa-solid fa-clock fs-4"></i>
                      </div>
                      <DatePicker
                        placeholder="Select Time"
                        disableDayPicker
                        value={serviceSttm}
                        onChange={(val) => {
                          console.log("🟡 Changed Start Time to:", val.format?.("HH:mm"));
                          setServiceSttm(val);
                        }}
                        format="HH:mm"
                        plugins={[<TimePicker position="bottom" />]}
                      />
                    </div>
                    {errors.production_start_time && (
                      <div className="text-danger">{errors.production_start_time}</div>
                    )}
                  </div>
                  {/* Production End Time */}
                  <div className="col-lg-6 mb-4">
                    <label className="text-black font-w500 fs-7">
                      Production End Time <span className="required">*</span>
                    </label>
                    <div className="datepicker-wrapper d-flex border-bottom border-gray-300">
                      <div className="input-group-text bg-transparent border-0 px-0">
                        <i className="fa-solid fa-clock fs-4"></i>
                      </div>
                      <DatePicker
                        placeholder="Select Time"
                        disableDayPicker
                        value={serviceEdtm}
                        onChange={(val) => {
                          console.log("🟡 Changed End Time to:", val.format?.("HH:mm"));
                          setServiceEdtm(val);
                        }}
                        format="HH:mm"
                        plugins={[<TimePicker position="bottom" />]}
                      />
                    </div>
                    {errors.production_end_time && (
                      <div className="text-danger">{errors.production_end_time}</div>
                    )}
                  </div>
                </div>
              </div>

              <div className="col-lg-4 mb-4">
                <label className="text-black font-w500 fs-7 d-block">Product Image</label>
                <span className="fs-8 text-gray-800">Size:</span>
                <span className="fs-8 text-danger"> 15 * 15</span>
                <span className="fs-8 text-gray-800 ms-2">Format:</span>
                <span className="fs-8 text-danger">.png, .jpg</span>

                <div className="avatar-upload d-flex align-items-center">
                  <div className="change position-relative px-0">
                    <div className="avatar-preview h-80px w-100px border" style={{ borderRadius: '10px' }}>
                      <img src={getImageSrc(file)} alt="Product Preview" className="p-1 h-80px w-100px" />
                    </div>
                    <div className="change-btn mt-2 d-flex justify-content-center gap-3">
                      <Button variant="success" size="sm" onClick={() => productImageInputRef.current.click()}>
                        <i className="fa fa-upload fs-5" />
                      </Button>
                      <Button variant="danger" size="sm" onClick={removeProductImage}>
                        <i className="fa fa-close fs-5" />
                      </Button>
                      <input
                        type="file"
                        accept=".png,.jpg,.jpeg"
                        ref={productImageInputRef}
                        style={{ display: 'none' }}
                        onChange={handleProductImageChange}
                      />
                    </div>
                    {productImageError && <span className="text-danger fs-8 d-block mt-1">{productImageError}</span>}
                  </div>
                </div>
              </div>
            </div>

            <div className='row'>
              <div className='col-lg-8'>
                <div className='row'>
                  <div className="col-lg-6 mb-4">
                    <label className="text-black font-w500 fs-7">
                      Packing Start Time<span className="required">*</span>
                    </label>
                    <div className="datepicker-wrapper d-flex border-bottom border-gray-300">
                      <div className="input-group-text bg-transparent border-0 px-0">
                        <i className="fa-solid fa-clock fs-4"></i>
                      </div>
                      <DatePicker
                        placeholder="Select Time"
                        disableDayPicker
                        value={packingSttm}
                        onChange={setPackingSttm}
                        format="HH:mm"
                        plugins={[<TimePicker />]}
                      />

                    </div>
                    {errors.packing_start_time && <div className="text-danger">{errors.packing_start_time}</div>}
                  </div>
                  <div className="col-lg-6 mb-4">
                    <label className="text-black font-w500 fs-7">Packing End Time<span className="required">*</span></label>
                    <div className='datepicker-wrapper d-flex border-bottom border-gray-300'>
                      <div className='input-group-text bg-transparent border-0 px-0'>
                        <i className='fa-solid fa-clock fs-4'></i>
                      </div>
                      <DatePicker
                        placeholder="Select Time"
                        disableDayPicker
                        value={packingEdtm}
                        onChange={setPackingEdtm}
                        format="HH:mm"
                        plugins={[<TimePicker />]}
                      />

                    </div>
                    {errors.packing_end_time && <div className="text-danger">{errors.packing_end_time}</div>}
                  </div>
                  <div className="col-lg-6 mb-4">
                    <label className="text-black font-w500 fs-7">Delivery Start Time<span className="required">*</span></label>
                    <div className='datepicker-wrapper d-flex border-bottom border-gray-300'>
                      <div className='input-group-text bg-transparent border-0 px-0'>
                        <i className='fa-solid fa-clock fs-4'></i>
                      </div>
                      <DatePicker
                        placeholder="Select Time"
                        disableDayPicker
                        value={deliverySttm}
                        onChange={setDeliverySttm}
                        format="HH:mm"
                        plugins={[<TimePicker />]}
                      />

                    </div>
                    {errors.delivery_start_time && <div className="text-danger">{errors.delivery_start_time}</div>}
                  </div>
                  <div className="col-lg-6 mb-4">
                    <label className="text-black font-w500 fs-7">Delivery End Time<span className="required">*</span></label>
                    <div className='datepicker-wrapper d-flex border-bottom border-gray-300'>
                      <div className='input-group-text bg-transparent border-0 px-0'>
                        <i className='fa-solid fa-clock fs-4'></i>
                      </div>
                      <DatePicker
                        placeholder="Select Time"
                        disableDayPicker
                        value={deliveryEdtm}
                        onChange={setDeliveryEdtm}
                        format="HH:mm"
                        plugins={[<TimePicker />]}
                      />

                    </div>
                    {errors.delivery_end_time && <div className="text-danger">{errors.delivery_end_time}</div>}
                  </div>
                </div>
              </div>
              <div className="col-lg-4 mb-4">
                <label className="text-black font-w500 fs-7 d-block">Brand Image</label>
                <span className="fs-8 text-gray-800">Size:</span>
                <span className="fs-8 text-danger"> 15 * 15</span>
                <span className="fs-8 text-gray-800 ms-2">Format:</span>
                <span className="fs-8 text-danger">.png, .jpg</span>

                <div className="avatar-upload d-flex align-items-center">
                  <div className="change position-relative px-0">
                    <div className="avatar-preview h-80px w-100px border" style={{ borderRadius: '10px' }}>
                      <img src={getImageSrc(brandImageFile)} alt="Brand Preview" className="p-1 h-80px w-100px" />
                    </div>
                    <div className="change-btn mt-2 d-flex justify-content-center gap-3">
                      <Button variant="success" size="sm" onClick={() => brandImageInputRef.current.click()}>
                        <i className="fa fa-upload fs-5" />
                      </Button>
                      <Button variant="danger" size="sm" onClick={removeBrandImage}>
                        <i className="fa fa-close fs-5" />
                      </Button>
                      <input
                        type="file"
                        accept=".png,.jpg,.jpeg"
                        ref={brandImageInputRef}
                        style={{ display: 'none' }}
                        onChange={handleBrandImageChange}
                      />
                    </div>
                    {brandImageError && <span className="text-danger fs-8 d-block mt-1">{brandImageError}</span>}
                  </div>
                </div>
              </div>
            </div>

            <div className='row'>
              <div className="col-lg-4 mb-4">
                <label className="text-black font-w500 fs-7">Product Color <span className="required">*</span></label>
                {/* <input type="color" className="form-control" placeholder="Choose Product Color" /> */}
                <input
                  type="color"
                  className="form-control"
                  value={productColor}
                  onChange={(e) => setProductColor(e.target.value)}
                  placeholder="Choose Product Color"
                />
              </div>
              <div className="col-lg-8">
                <label className="text-black font-w500 fs-7">Description</label>
                <textarea
                  rows={4}
                  className="form-control"
                  value={description}
                  onChange={(e) => setDescription(toTitleCase(e.target.value))}
                  placeholder="Description"
                  maxLength={100}
                />
              </div>
            </div>

            <div className="row">
              {/* Number of Item Categories (auto counted) */}
              <div className="col-lg-4 mb-4 position-relative">
                <label className="text-black font-w500 fs-7">
                  Number of Item Categories <span className="required">*</span>
                </label>
                <div style={{ position: 'relative' }}>
                  <input
                    type="number"
                    className="form-control pe-5"
                    value={itemCategory.length}
                    readOnly
                  />
                  <button
                    type="button"
                    className="btn btn-success position-absolute top-50 translate-middle-y"
                    style={{ right: '8px', padding: '4px 10px', zIndex: 10 }}
                    onClick={() => {
                      const updated = [...itemCategory];
                      updated.push({
                        id: `item_${updated.length}_${Date.now()}`,
                        category: null,
                        count: '1', // default dummy count
                        subcategories: [],
                      });
                      setItemCategory(updated);
                    }}
                  >
                    <i className="fa fa-plus"></i>
                  </button>
                </div>
              </div>

              {/* Item Category Rows */}
              {itemCategory.length > 0 && (
                <div className="col-lg-12">
                  <label className="text-black font-w500 fs-7">
                    Item Categories & Subcategories <span className="required">*</span>
                  </label>
                  <div
                    style={{
                      maxHeight: '250px',
                      overflowY: 'auto',
                      overflowX: 'hidden',
                      paddingRight: '10px',
                      border: '1px solid #dee2e6',
                      borderRadius: '5px',
                      padding: '10px',
                    }}
                  >
                    {itemCategory.map((item, index) => {
                      const availableCategoryOptions = optionsItemCategory.filter(
                        (option) =>
                          !itemCategory.some(
                            (selectedItem, selectedIndex) =>
                              selectedIndex !== index &&
                              selectedItem.category?.value === option.value
                          )
                      );

                      return (
                        <div className="row mb-3 align-items-end" key={item.id || index}>
                          {/* Category Select */}
                          <div className="col-lg-4">
                            <label className="text-black font-w500 fs-7">
                              Item Category #{index + 1} <span className="required">*</span>
                            </label>
                            <Select
                              placeholder={`Select Item Category #${index + 1}`}
                              value={item.category}
                              onChange={(selected) => {
                                const updated = [...itemCategory];
                                updated[index] = {
                                  ...updated[index],
                                  category: selected,
                                  subcategories: [],
                                };
                                setItemCategory(updated);
                              }}
                              options={availableCategoryOptions}
                              menuPlacement="top"
                              menuPortalTarget={document.body}
                              styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
                              // className={itemcatErrors[`category_${index}`] ? 'is-invalid' : ''}
                              className={itemcatErrors[`category_${index}`] ? 'is-invalid' : ''}
                            />

                            {itemcatErrors[`category_${index}`] && (
                              <span className="text-danger fs-8">
                                {itemcatErrors[`category_${index}`]}
                              </span>
                            )}
                          </div>

                          {/* Subcategory Multi-Select */}
                          <div className="col-lg-6">
                            <label className="text-black font-w500 fs-7">
                              Item Subcategories #{index + 1} <span className="required">*</span>
                            </label>
                            <Select
                              isMulti
                              placeholder="Select Subcategories"
                              value={item.subcategories || []}
                              onChange={(selectedOptions) => {
                                const updated = [...itemCategory];
                                updated[index] = {
                                  ...updated[index],
                                  subcategories: selectedOptions,
                                };
                                setItemCategory(updated);
                              }}
                              options={
                                item.category?.value
                                  ? groupedSubCategories[item.category.value] || []
                                  : []
                              }
                              menuPlacement="top"
                              menuPortalTarget={document.body}
                              styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
                            />

                            {itemcatErrors[`subcategory_${index}`] && (
                              <span className="text-danger fs-8">
                                {itemcatErrors[`subcategory_${index}`]}
                              </span>
                            )}
                          </div>

                          {/* Dummy Count */}
                          <div className="col-lg-2 d-none">
                            <label className="text-black font-w500 fs-7">
                              Count <span className="required">*</span>
                            </label>
                            <input
                              type="number"
                              min={1}
                              className="form-control"
                              value={item.count}
                              onChange={(e) => {
                                const updated = [...itemCategory];
                                updated[index].count = e.target.value;
                                setItemCategory(updated);
                              }}
                            />
                          </div>

                          {/* Delete Button */}
                          <div className="col-lg-2 text-end">
                            <button
                              type="button"
                              className="btn btn-sm btn-danger"
                              onClick={() => {
                                const updated = [...itemCategory];
                                updated.splice(index, 1);
                                setItemCategory(updated);
                              }}
                              disabled={itemCategory.length <= 1}
                            >
                              <i className="fa fa-trash"></i>
                            </button>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              )}
            </div>

            <div className="d-flex align-items-center justify-content-end gap-3 mt-4 mb-4">
              <button type="submit" className="btn btn-sm btn-primary">Update Product <i className="fas fa-angle-double-right ms-2"></i></button>
            </div>

          </form>
        </div>
      </div>
    </Modal>
  );
};

export default EditProduct;
